import { apiBankList } from '@/network/api/api';
import { useRequest } from 'ahooks';
import type { FormInstance } from 'antd';
import { Form, Input, Select } from 'antd';
import FormItem from 'antd/es/form/FormItem';

interface BankInfoFormProps {
  formRef: FormInstance;
  formData: React.MutableRefObject<any[]>;
  isCreateScenic: boolean;
  onFinish: (title?: string) => void;
}

const BankInfoForm: React.FC<BankInfoFormProps> = ({
  formRef,
  formData,
  isCreateScenic,
  onFinish,
}) => {
  const bankDownListReq = useRequest(apiBankList, {});

  return (
    <Form layout="vertical" form={formRef} size="large" onFinish={onFinish}>
      <FormItem label="开户名称" name="accountName">
        <Input defaultValue={formData.current[isCreateScenic ? 1 : 0]?.coName ?? ''} disabled />
      </FormItem>
      <FormItem name="bankName" hidden={true} />
      <FormItem label="开户银行" name="bankId">
        <Select
          loading={bankDownListReq.loading}
          onChange={(value, option: any) => {
            console.log(value, option);
            formRef.setFieldValue('bankName', option.label);
          }}
          options={bankDownListReq.data?.data?.map(({ bankId, bankName }) => {
            return {
              label: bankName,
              value: bankId,
            };
          })}
          placeholder="请选择"
        />
      </FormItem>
      <FormItem label="银行账户" name="account">
        <Input placeholder="请输入" />
      </FormItem>
    </Form>
  );
};

export default BankInfoForm;
